<template>
  <div id="program-accordion" class="accordion accordion-icons">
    <div class="card accordion__card">
      <header class="card-header" role="tab">
        <section class="mb-0 mt-0">
          <div class="collapsed accordion__heading">
            <button
              class="accordion__control collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#public"
              aria-expanded="false"
              aria-controls="public"
            >
              <div class="accordion-icon">
                <FontAwesomeIcon icon="fa-light fa-users" />
              </div>
              {{ $t("training.program.target_audience") }} / {{ $t("training.program.prerequisites") }}
            </button>
            <button class="btn-icon me-2 accordion__edit btnEditPublic" @click="editTargetAudience">
              <FontAwesomeIcon icon="fa-light fa-pen" />
            </button>
            <button
              data-bs-toggle="collapse"
              data-bs-target="#public"
              aria-expanded="false"
              aria-controls="public"
              class="icons collapsed"
            >
              <FontAwesomeIcon icon="fa-light fa-angle-down" />
            </button>
          </div>
        </section>
      </header>
      <div id="public" class="collapse" aria-labelledby="public" data-bs-parent="#program-accordion">
        <div class="card-body accordion__body">{{ training.targetAudience }}</div>
      </div>
    </div>
    <div class="card accordion__card">
      <header class="card-header" role="tab">
        <section class="mb-0 mt-0">
          <div class="collapsed accordion__heading" role="menu">
            <button
              class="accordion__control collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#target"
              aria-expanded="false"
              aria-controls="target"
            >
              <div class="accordion-icon">
                <FontAwesomeIcon icon="fa-light fa-bullseye-arrow" />
              </div>
              {{ $t("training.program.training_targets") }}
            </button>
            <button class="btn-icon me-2 accordion__edit btnEditTarget" @click.stop="editObjectives">
              <FontAwesomeIcon icon="fa-light fa-pen" />
            </button>
            <button
              data-bs-toggle="collapse"
              data-bs-target="#target"
              aria-expanded="false"
              aria-controls="target"
              class="icons collapsed"
            >
              <FontAwesomeIcon class="angle-down" icon="fa-light fa-angle-down" />
            </button>
          </div>
        </section>
      </header>
      <div id="target" class="collapse" aria-labelledby="target" data-bs-parent="#program-accordion">
        <div class="card-body accordion__body">
          {{ training.objectives }}
        </div>
      </div>
    </div>
    <div class="card accordion__card">
      <header class="card-header" role="tab">
        <section class="mb-0 mt-0">
          <div class="collapsed accordion__heading" role="menu">
            <button
              class="accordion__control collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#informations"
              aria-expanded="false"
              aria-controls="informations"
            >
              <div class="accordion-icon">
                <FontAwesomeIcon icon="fa-light fa-circle-info" />
              </div>
              {{ $t("training.program.informations") }}
            </button>
            <button class="btn-icon me-2 accordion__edit btnEditInformation" @click.stop="editPracticalInfo">
              <FontAwesomeIcon icon="fa-light fa-pen" />
            </button>
            <button
              data-bs-toggle="collapse"
              data-bs-target="#informations"
              aria-expanded="false"
              aria-controls="informations"
              class="icons collapsed"
            >
              <FontAwesomeIcon icon="fa-light fa-angle-down" />
            </button>
          </div>
        </section>
      </header>
      <div id="informations" class="collapse" aria-labelledby="informations" data-bs-parent="#program-accordion">
        <div class="card-body accordion__body">
          <TrainingProgramAccordionInformationsComponent :training="training" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import TrainingProgramAccordionInformationsComponent from "@/components/training/program/TrainingProgramAccordionInformationsComponent.vue";

export default {
  name: "TrainingProgramAccordionComponent",
  emit: ["edit"],
  components: {
    TrainingProgramAccordionInformationsComponent,
    FontAwesomeIcon,
  },
  props: {
    training: {
      type: Object,
      required: true,
    },
  },
  methods: {
    editTargetAudience(e) {
      e.stopPropagation();
      this.$emit("edit", "target-audience");
    },
    editObjectives() {
      this.$emit("edit", "objectives");
    },
    editPracticalInfo() {
      this.$emit("edit", "practical-info");
    },
  },
};
</script>

<style lang="scss" scoped>
.accordion {
  margin-top: 20px;
  &__card + &__card {
    margin-top: 15px;
  }

  &__card {
    overflow: hidden;
    .card-header {
      border-bottom: none;
      padding: 0;
      cursor: pointer;
    }
  }

  &__body {
    @include dark-theme {
      color: $white;
    }
  }

  &__edit {
    position: absolute;
    right: 35px;
    top: 50%;
    transform: translateY(-50%);
  }

  &__heading {
    display: flex;
    position: relative;
    font-weight: 700;
    color: var(--primary-color);

    @include dark-theme {
      color: $white;
    }

    @include up-to-md {
      padding: 20px 60px 20px 20px;
    }

    .accordion-icon {
      margin-right: 8px;
      font-size: 16px;
    }

    .icons {
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%) rotate(180deg);
      background: none;
      color: $black;
      border: none;

      &.collapsed {
        transform: translateY(-50%) rotate(0);
      }
    }
  }

  &__control {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 20px;
    background: none;
    color: $black;
    border: none;
  }
}
</style>
